import {
    Delete as DeleteIcon,
    Edit as EditIcon,
    Add as AddIcon,
    LiveHelp
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import blogsService from "../../../services/blogs.service";
import FAQModalContent from "./faqForm";

const headerCells = [
    {
        field: "title",
        title: "عنوان",
        mainField: true,
    },
    {
        field: "summary",
        title: "خلاصه",
        mainField: false,
    },
    {
        field: "imageCol",
        title: "عکس",
        mainField: false,
    },
    {
        field: "status",
        title: "وضعیت",
        mainField: false,
    },
];
const defaultKeys = [
    {
        title: "نام",
        field: "title",
        active: true,
    },
];

export default function BlogsPage() {
    const deleteItem = (item) => {
        return blogsService.deleteBlog(item.id);
    };

    const changeData = (data) => {
        return data.map(item => {
            item.faq = item.faq ? JSON.parse(item.faq) : [];
            if (item.image) {
                item.imageCol = (
                    <img src={item.image} style={{ maxHeight: "100px" }} />
                );
            }

            return item
        })
    }

    return (
        <div className="p-3">
            <DataTable
                headCells={headerCells}
                backend={blogsService.getBlogsUrl}
                changeData={changeData}
                rowActions={[
                    {
                        modalProps: { maxWidth: "lg" },
                        icon: <LiveHelp />,
                        modalContent: (props) => <FAQModalContent {...props} />,
                    },
                    {
                        modalProps: { maxWidth: "lg" },
                        icon: <EditIcon />,
                        modalContent: (props) => <FormModalContent {...props} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <DeleteIcon />,
                        modalContent: (props) => (
                            <ConfirmModalContent
                                onConfirm={() => deleteItem(props.data)}
                                confirmText={props.data.name}
                                close={props.close}
                            />
                        ),
                    },
                ]}
                actions={[
                    {
                        modalProps: { maxWidth: "lg" },
                        icon: <AddIcon />,
                        tooltip: "ایجاد بلاگ",
                        modalContent: (props) => <FormModalContent {...props} />,
                    },
                ]}
                searchKeys={defaultKeys}
                title="بلاگ ها"
            />
        </div>
    );
}
